import './index.scss';

import { ChangeEvent, Component, ReactNode } from 'react';

import { UncontrolledField } from '..';
import { BraxUncontrolledField } from '../BraxUncontrolledField';
import { BraxIcon } from 'components/BraxIcon';

export type BraxUncontrolledRangeFieldProps = UncontrolledField<number> & {
    label: ReactNode,
    min: number,
    max: number,
    step?: number | 'any',
    hint?: ReactNode,
    required?: boolean,
    onChange?: (value: number, event: ChangeEvent<HTMLInputElement>) => void
};

export class BraxUncontrolledRangeField extends Component<BraxUncontrolledRangeFieldProps> {

    static defaultProps = {
        disabled: false,
        status: null,
        step: 'any'
    };

    change(event: ChangeEvent<HTMLInputElement>) {
        if (this.props.onChange)
            this.props.onChange(Number(event.target.value), event);
    }

    render() {
        let { id, label, status, required, value: _value, onChange, ...props } = this.props;

        const { min, max } = props;

        const value = Math.round(typeof _value !== 'number' ? (max - min) / 2 + min : _value);

        const percentageValue = (value - min) / (max - min) * 100;

        return (
            <BraxUncontrolledField id={id}>
                { ({ id }) => (
                    <div className={`brax-range-field ${status}`}>
                        <label>{ label } { required ? '*' : null }</label>

                        <div>
                            <input
                                id={id}
                                type="range"
                                value={value}
                                onChange={event => this.change(event)}
                                style={{ '--percentage-value': `${percentageValue}%` } as any}
                                {...props}
                            />

                            <label htmlFor={id} className="complementary-title" style={{ left: `calc(${percentageValue}% - ${(20 / 100 * percentageValue)}px` }}>
                                <span>{ min < 0 && value > 0 ? `+${value}` : value }</span>
                            </label>

                            <span>{ min }</span>

                            <span>{ min < 0 ? `+${max}` : max }</span>
                        </div>

                        { this.props.hint ? (
                            <p className="hint">
                                { this.props.status === 'error' ? <BraxIcon icon="exclamation-mark" /> : null }

                                <span>{ this.props.hint }</span>
                            </p>
                        ) : null }
                    </div>
                ) }
            </BraxUncontrolledField>
        );
    }

}
